/* ============================================================
   PARTNER PORTAL — Ajout de photographies (Uploadcare 3.x isolé)
   ELOISE ACCESSOIRES · lot 12D-B
   - JS natif, IIFE, mode strict. Namespace : window.__pp.
   - Aucune dépendance, aucun build, aucun fetch, aucun payload.
   - Aucun input file, aucun fallback natif, aucun hidden input.
   - Uploadcare chargé paresseusement, une seule fois, hors design_mode.
   - Isolation stricte : ne réutilise jamais window._ep / epCard / .ep__.
   - Validation de taille : validateur personnalisé passé à openDialog
     (mécanisme garanti du Widget 3.x) + revérification de info.size.
     N'appelle PAS window.uploadcare.validators.fileSizeLimit (non confirmé).
   ============================================================ */
(function () {
  'use strict';

  var CDN = 'https://ucarecdn.com/libs/widget/3.x/uploadcare.full.min.js';
  var SUBMIT_ENDPOINT = '/apps/partner-portal/professional-requests';
  var ALLOWED_EXT = ['jpg', 'jpeg', 'png', 'webp'];
  var TARGET = {
    panoramic: { w: 4080, h: 2100 },
    front: { w: 2040, h: 2100 },
    back: { w: 2040, h: 2100 }
  };
  var ROLE_LABEL = {
    panoramic: 'Photographie panoramique',
    front: 'Face avant',
    back: 'Face arrière'
  };
  var ROLE_ALT = {
    panoramic: 'Aperçu de la photographie panoramique',
    front: 'Aperçu de la face avant',
    back: 'Aperçu de la face arrière'
  };
  var ROLE_HINT = {
    panoramic: '4080 × 2100 px recommandé',
    front: '2040 × 2100 px recommandé',
    back: '2040 × 2100 px recommandé'
  };
  var RATIO_TOLERANCE = 0.05;

  /* Compteurs de caractères (max métier + seuil visuel d'approche) */
  var COUNTER_CONF = {
    partner_internal_reference: { max: 60, threshold: 56, name: 'pp_partner_internal_reference' },
    text: { max: 50, threshold: 46, name: 'pp_text' },
    instructions: { max: 250, threshold: 230, name: 'pp_instructions' }
  };

  /* Champs du client final (ordre = ordre DOM ; address2 seul facultatif) */
  var EC_FIELDS = [
    { key: 'first_name', required: true },
    { key: 'last_name', required: true },
    { key: 'address1', required: true },
    { key: 'address2', required: false },
    { key: 'postal_code', required: true },
    { key: 'city', required: true },
    { key: 'country', required: true },
    { key: 'email', required: true },
    { key: 'phone', required: true }
  ];
  var EC_COUNTRIES = ['FR', 'BE', 'LU', 'MC'];

  /* Comptage par points de code (emoji / Unicode comptés comme l'affichage) */
  function codePointLength(v) {
    if (v === null || v === undefined) { return 0; }
    return Array.from(String(v)).length;
  }
  /* trim → null si vide (brouillon uniquement ; ne modifie jamais le champ) */
  function trimOrNull(v) {
    var t = String(v === null || v === undefined ? '' : v).trim();
    return t === '' ? null : t;
  }
  function looksLikeEmail(v) {
    var t = String(v === null || v === undefined ? '' : v).trim();
    return t.length > 0 && /.+@.+\..+/.test(t);
  }
  function phoneDigitCount(v) {
    var m = String(v === null || v === undefined ? '' : v).match(/\d/g);
    return m ? m.length : 0;
  }

  /* UUID v4 — crypto.randomUUID si dispo, sinon crypto.getRandomValues.
     Jamais Math.random (non cryptographique). Valeur éphémère (mémoire seule). */
  function uuidV4() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
        var b = new Uint8Array(16);
        window.crypto.getRandomValues(b);
        b[6] = (b[6] & 0x0f) | 0x40; // version 4
        b[8] = (b[8] & 0x3f) | 0x80; // variant 10xx
        var h = [];
        for (var i = 0; i < 256; i++) { h[i] = (i + 0x100).toString(16).slice(1); }
        return (h[b[0]] + h[b[1]] + h[b[2]] + h[b[3]] + '-' +
                h[b[4]] + h[b[5]] + '-' + h[b[6]] + h[b[7]] + '-' +
                h[b[8]] + h[b[9]] + '-' +
                h[b[10]] + h[b[11]] + h[b[12]] + h[b[13]] + h[b[14]] + h[b[15]]);
      }
    } catch (e) { /* ignore : retombe sur null ci-dessous */ }
    return null;
  }

  window.__pp = window.__pp || {
    instances: new Map(),
    uploadcarePromise: null,
    listenersBound: false
  };
  var PP = window.__pp;

  /* ---------- utils ---------- */
  function el(tag, cls) {
    var n = document.createElement(tag);
    if (cls) { n.className = cls; }
    return n;
  }
  function extOf(name) {
    if (!name || typeof name !== 'string') { return ''; }
    var i = name.lastIndexOf('.');
    return i >= 0 ? name.slice(i + 1).toLowerCase() : '';
  }
  function formatBytes(bytes) {
    if (typeof bytes !== 'number' || !isFinite(bytes) || bytes < 0) { return ''; }
    if (bytes < 1024) { return bytes + ' o'; }
    var kb = bytes / 1024;
    if (kb < 1024) { return (Math.round(kb * 10) / 10) + ' Ko'; }
    var mb = kb / 1024;
    return (Math.round(mb * 10) / 10) + ' Mo';
  }
  function rolesForMode(mode) {
    if (mode === 1) { return ['panoramic']; }
    if (mode === 2) { return ['front', 'back']; }
    return [];
  }

  /* ---------- chargement paresseux Uploadcare (une seule fois) ---------- */
  function loadUploadcare() {
    if (window.uploadcare && typeof window.uploadcare.openDialog === 'function') {
      return Promise.resolve(window.uploadcare);
    }
    if (PP.uploadcarePromise) { return PP.uploadcarePromise; }
    PP.uploadcarePromise = new Promise(function (resolve, reject) {
      try {
        window.UPLOADCARE_LOCALE = 'fr';
        window.UPLOADCARE_MANUAL_START = true;
        var existing = document.querySelector('script[data-pp-uploadcare-script]');
        if (existing) {
          existing.addEventListener('load', function () { resolve(window.uploadcare); });
          existing.addEventListener('error', function () { reject(new Error('uploadcare-load-failed')); });
          return;
        }
        var s = document.createElement('script');
        s.src = CDN;
        s.async = true;
        s.charset = 'utf-8';
        s.setAttribute('data-pp-uploadcare-script', '');
        s.onload = function () {
          if (window.uploadcare && typeof window.uploadcare.openDialog === 'function') {
            resolve(window.uploadcare);
          } else {
            reject(new Error('uploadcare-undefined'));
          }
        };
        s.onerror = function () { reject(new Error('uploadcare-load-failed')); };
        (document.head || document.documentElement).appendChild(s);
      } catch (e) { reject(e); }
    });
    return PP.uploadcarePromise;
  }

  /* ---------- Instance ---------- */
  function Instance(root) {
    this.root = root;
    this.designMode = root.getAttribute('data-pp-design-mode') === 'true';
    this.publicKey = root.getAttribute('data-pp-uploadcare-public-key') || '';
    this.maxFileBytes = parseInt(root.getAttribute('data-pp-max-file-bytes'), 10) || 26214400;
    this.maxTotalBytes = parseInt(root.getAttribute('data-pp-max-total-bytes'), 10) || 52428800;
    this.mode = 0;
    this.pendingMode = 0;
    this.slots = {};

    this.slotsHost = root.querySelector('[data-pp-upload-slots]');
    this.emptyState = root.querySelector('[data-pp-upload-empty-state]');
    this.statusEl = root.querySelector('[data-pp-upload-status]');
    this.confirmEl = root.querySelector('[data-pp-mode-confirmation]');
    this.consentEl = root.querySelector('[data-pp-production-rights-consent]');
    this.compRadios = Array.prototype.slice.call(root.querySelectorAll('input[name="pp_composition"]'));

    /* --- 12E-B : formulaire dynamique local (état miroir + brouillon) --- */
    this.form = root.querySelector('[data-pp-form]');
    this.formStatusEl = root.querySelector('[data-pp-form-status]');
    this.errorSummaryEl = root.querySelector('[data-pp-error-summary]');

    /* --- EXPRESS-7B : soumission contrôlée (POST réel) --- */
    this.submitBtn = root.querySelector('[data-pp-submit]');
    this.submitErrorEl = root.querySelector('[data-pp-submit-error]');
    this.successEl = root.querySelector('[data-pp-success]');
    this.footNoteEl = root.querySelector('[data-pp-form-foot-note]');
    this.submitBtnDefaultLabel = this.submitBtn ? this.submitBtn.textContent : 'Envoyer ma demande';
    /* État de soumission — jamais autoritaire côté métier (Laravel = source de vérité). */
    this.submitting = false;
    this.submitted = false;
    this.idempotencyKey = null;
    this.idempotencyPayloadSignature = null;

    this.refInput = root.querySelector('input[name="pp_partner_internal_reference"]');
    this.textInput = root.querySelector('textarea[name="pp_text"]');
    this.instrInput = root.querySelector('textarea[name="pp_instructions"]');
    this.socleRadios = Array.prototype.slice.call(root.querySelectorAll('input[name="pp_couleur_socle"]'));
    this.shippingRadios = Array.prototype.slice.call(root.querySelectorAll('input[name="pp_shipping_destination"]'));
    this.contentReuseEl = root.querySelector('[data-pp-content-reuse-consent]');

    this.ecFieldset = root.querySelector('[data-pp-end-customer]');
    this.destConfirmEl = root.querySelector('[data-pp-destination-confirmation]');
    this.pendingShippingMode = null;

    /* Champs client final indexés par clé + zones d'erreur associées */
    this.ecInputs = {};
    this.ecErrors = {};
    var ecNodes = root.querySelectorAll('[data-pp-ec-field]');
    for (var e = 0; e < ecNodes.length; e++) {
      this.ecInputs[ecNodes[e].getAttribute('data-pp-ec-field')] = ecNodes[e];
    }
    var errNodes = root.querySelectorAll('[data-pp-field-error-for]');
    for (var f = 0; f < errNodes.length; f++) {
      this.ecErrors[errNodes[f].getAttribute('data-pp-field-error-for')] = errNodes[f];
    }

    /* Compteurs de caractères indexés par clé */
    this.counters = {};
    var cNodes = root.querySelectorAll('[data-pp-counter]');
    for (var c = 0; c < cNodes.length; c++) {
      var key = cNodes[c].getAttribute('data-pp-counter-for');
      var conf = COUNTER_CONF[key];
      if (!conf) { continue; }
      this.counters[key] = {
        el: cNodes[c],
        input: root.querySelector('[name="' + conf.name + '"]'),
        max: conf.max,
        threshold: conf.threshold
      };
    }

    /* Miroir normalisé — jamais une seconde source de vérité (le DOM prime) */
    this.formState = {
      partnerInternalReference: '',
      text: '',
      instructions: '',
      baseColor: null,
      shippingMode: null,
      endCustomer: null,
      productionRightsConsent: false,
      contentReuseConsent: false,
      touched: new Set()
    };
  }

  Instance.prototype.status = function (msg) {
    if (this.statusEl) { this.statusEl.textContent = msg || ''; }
  };

  Instance.prototype.consentGiven = function () {
    return !!(this.consentEl && this.consentEl.checked);
  };

  Instance.prototype.hasAnyFile = function () {
    var r, roles = rolesForMode(this.mode);
    for (var i = 0; i < roles.length; i++) {
      r = this.slots[roles[i]];
      if (r && r.state === 'ready') { return true; }
    }
    return false;
  };

  Instance.prototype.totalBytesExcept = function (exceptRole) {
    var total = 0, role, s, roles = rolesForMode(this.mode);
    for (var i = 0; i < roles.length; i++) {
      role = roles[i];
      if (role === exceptRole) { continue; }
      s = this.slots[role];
      if (s && s.state === 'ready' && typeof s.size === 'number') { total += s.size; }
    }
    return total;
  };

  /* ---------- rendu des emplacements ---------- */
  Instance.prototype.renderSlots = function () {
    if (!this.slotsHost) { return; }
    this.slotsHost.innerHTML = '';
    var roles = rolesForMode(this.mode);
    if (this.emptyState) { this.emptyState.hidden = roles.length > 0; }

    for (var i = 0; i < roles.length; i++) {
      this.slotsHost.appendChild(this.buildSlot(roles[i]));
    }
  };

  Instance.prototype.buildSlot = function (role) {
    var self = this;
    var wrap = el('div', 'pp__upload-slot');
    wrap.setAttribute('data-pp-upload-slot', '');
    wrap.setAttribute('data-pp-upload-role', role);
    wrap.setAttribute('data-pp-upload-state', 'empty');

    var head = el('p', 'pp__upload-slot-role');
    head.textContent = ROLE_LABEL[role];
    wrap.appendChild(head);

    var hint = el('p', 'pp__upload-slot-hint');
    hint.textContent = ROLE_HINT[role];
    wrap.appendChild(hint);

    var body = el('div', 'pp__upload-slot-body');
    wrap.appendChild(body);

    var slot = this.slots[role] || { role: role, state: 'empty' };
    this.slots[role] = slot;
    slot.wrap = wrap;
    slot.body = body;

    // Bouton "Ajouter"
    var addBtn = el('button', 'pp__button pp__button--upload');
    addBtn.type = 'button';
    addBtn.setAttribute('data-pp-upload-add', '');
    addBtn.textContent = 'Ajouter la photographie';
    addBtn.addEventListener('click', function () { self.onAdd(role); });
    slot.addBtn = addBtn;

    this.paintSlot(role);
    this.refreshConsentGate();
    return wrap;
  };

  Instance.prototype.paintSlot = function (role) {
    var slot = this.slots[role];
    if (!slot || !slot.body) { return; }
    var body = slot.body;
    body.innerHTML = '';
    slot.wrap.setAttribute('data-pp-upload-state', slot.state);

    if (slot.state === 'empty') {
      body.appendChild(slot.addBtn);
      return;
    }
    if (slot.state === 'opening' || slot.state === 'loading' || slot.state === 'processing') {
      var loading = el('p', 'pp__upload-loading');
      loading.setAttribute('aria-live', 'polite');
      loading.textContent = slot.state === 'processing'
        ? 'Traitement de la photographie…'
        : 'Téléversement en cours…';
      body.appendChild(loading);
      return;
    }
    if (slot.state === 'error') {
      var err = el('p', 'pp__upload-error');
      err.textContent = slot.error || 'Impossible d’ajouter cette photographie. Réessayez.';
      body.appendChild(err);
      var retry = el('button', 'pp__button pp__button--upload');
      retry.type = 'button';
      retry.textContent = 'Réessayer';
      var self = this;
      retry.addEventListener('click', function () { self.onAdd(role); });
      body.appendChild(retry);
      return;
    }
    if (slot.state === 'ready') {
      var fig = el('div', 'pp__upload-preview');
      if (slot.cdnUrl) {
        var img = el('img', 'pp__upload-preview-img');
        img.src = slot.cdnUrl + '-/preview/240x240/-/quality/smart/';
        img.alt = ROLE_ALT[role];
        img.loading = 'lazy';
        img.width = 120;
        img.height = 120;
        fig.appendChild(img);
      }
      body.appendChild(fig);

      var meta = el('div', 'pp__upload-meta');
      if (slot.name) {
        var nm = el('p', 'pp__upload-name');
        nm.textContent = slot.name;
        meta.appendChild(nm);
      }
      var line = el('p', 'pp__upload-metaline');
      var parts = [];
      if (typeof slot.size === 'number') { parts.push(formatBytes(slot.size)); }
      if (typeof slot.width === 'number' && typeof slot.height === 'number' &&
          slot.width > 0 && slot.height > 0) {
        parts.push(slot.width + ' × ' + slot.height + ' px');
      }
      line.textContent = parts.join(' · ');
      if (parts.length) { meta.appendChild(line); }
      body.appendChild(meta);

      if (slot.warnings && slot.warnings.length) {
        var wl = el('ul', 'pp__upload-warnings');
        for (var w = 0; w < slot.warnings.length; w++) {
          var li = el('li', 'pp__upload-warning');
          li.textContent = slot.warnings[w];
          wl.appendChild(li);
        }
        body.appendChild(wl);
      }

      var actions = el('div', 'pp__upload-actions');
      var self2 = this;
      var repl = el('button', 'pp__button pp__button--ghost');
      repl.type = 'button';
      repl.textContent = 'Remplacer';
      repl.addEventListener('click', function () { self2.onAdd(role); });
      var del = el('button', 'pp__button pp__button--danger');
      del.type = 'button';
      del.textContent = 'Supprimer';
      del.addEventListener('click', function () { self2.onDelete(role); });
      actions.appendChild(repl);
      actions.appendChild(del);
      body.appendChild(actions);
      return;
    }
  };

  /* ---------- gate consentement ---------- */
  Instance.prototype.refreshConsentGate = function () {
    var enabled = this.consentGiven();
    var roles = rolesForMode(this.mode);
    for (var i = 0; i < roles.length; i++) {
      var slot = this.slots[roles[i]];
      if (slot && slot.addBtn) {
        var blocked = !enabled;
        slot.addBtn.disabled = blocked;
        slot.addBtn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      }
    }
  };

  /* ---------- ajout / ouverture ---------- */
  Instance.prototype.onAdd = function (role) {
    // Consentement obligatoire
    if (!this.consentGiven()) {
      this.status('Confirmez l’autorisation de traitement pour ajouter les photographies.');
      if (this.consentEl && typeof this.consentEl.focus === 'function') { this.consentEl.focus(); }
      return;
    }
    // Éditeur : aucun réseau, aucun dialogue réel
    if (this.designMode) {
      this.status('Aperçu éditeur — ajout de photographies désactivé.');
      return;
    }
    // Absence de clé publique : service indisponible
    if (!this.publicKey) {
      this.status('Service d’ajout de photographies temporairement indisponible.');
      return;
    }

    var self = this;
    var slot = this.slots[role];
    slot.state = 'opening';
    this.paintSlot(role);
    this.status('Ouverture du sélecteur…');

    loadUploadcare().then(function (uc) {
      var maxBytes = self.maxFileBytes;
      var settings = {
        publicKey: self.publicKey,
        imagesOnly: true,
        locale: 'fr',
        clearable: false,
        multiple: false,
        validators: [function (fileInfo) {
          if (fileInfo && fileInfo.size !== null && typeof fileInfo.size === 'number' &&
              fileInfo.size > maxBytes) {
            throw new Error('fileMaximumSize');
          }
        }]
      };
      var dialog = uc.openDialog(null, settings);
      dialog.done(function (fileObj) {
        slot.state = 'loading';
        self.paintSlot(role);
        self.status('Téléversement en cours…');
        fileObj.promise().then(function (info) {
          slot.state = 'processing';
          self.paintSlot(role);
          self.applyReady(role, info);
        }).catch(function () {
          self.setError(role, 'Impossible d’ajouter cette photographie. Réessayez.');
        });
      });
      if (typeof dialog.fail === 'function') {
        dialog.fail(function () {
          // Annulation ou échec du dialogue : revenir à l'état précédent sans erreur trompeuse
          if (slot.state === 'opening') {
            slot.state = slot.cdnUrl ? 'ready' : 'empty';
            self.paintSlot(role);
            self.status('');
          }
        });
      }
    }).catch(function () {
      self.setError(role, 'Service d’ajout indisponible pour le moment. Réessayez.');
    });
  };

  Instance.prototype.setError = function (role, msg) {
    var slot = this.slots[role];
    slot.state = 'error';
    slot.error = msg;
    this.paintSlot(role);
    this.status(msg);
    this.refreshConsentGate();
    this.updateSubmitButtonState();
  };

  /* ---------- validation + application d'un fichier prêt ---------- */
  Instance.prototype.applyReady = function (role, info) {
    var name = info && info.name ? String(info.name) : '';
    var size = info && typeof info.size === 'number' ? info.size : null;

    // Type
    var ext = extOf(name);
    if (ext && ALLOWED_EXT.indexOf(ext) === -1) {
      this.setError(role, 'Format non accepté. Utilisez JPG, JPEG, PNG ou WEBP.');
      return;
    }
    // Taille par fichier
    if (size !== null && size > this.maxFileBytes) {
      this.setError(role, 'Le fichier dépasse la limite de 25 Mo.');
      return;
    }
    // Taille totale (en tenant compte d'un remplacement du même emplacement)
    if (size !== null) {
      var projected = this.totalBytesExcept(role) + size;
      if (projected > this.maxTotalBytes) {
        this.setError(role, 'L’ensemble des photographies dépasse la limite de 50 Mo.');
        return;
      }
    }

    // Dimensions uniquement si réellement fournies
    var width = null, height = null;
    if (info && info.originalImageInfo &&
        typeof info.originalImageInfo.width === 'number' && info.originalImageInfo.width > 0 &&
        typeof info.originalImageInfo.height === 'number' && info.originalImageInfo.height > 0) {
      width = info.originalImageInfo.width;
      height = info.originalImageInfo.height;
    }

    var warnings = this.computeWarnings(role, width, height);

    // Remplacement validé uniquement après succès du nouveau fichier
    this.slots[role] = {
      role: role,
      uuid: info && info.uuid ? info.uuid : null,
      cdnUrl: info && info.cdnUrl ? info.cdnUrl : null,
      name: name,
      size: size,
      width: width,
      height: height,
      warnings: warnings,
      state: 'ready',
      wrap: this.slots[role].wrap,
      body: this.slots[role].body,
      addBtn: this.slots[role].addBtn
    };
    this.paintSlot(role);
    this.status('Photographie ajoutée.');
    this.refreshConsentGate();
    this.updateSubmitButtonState();
  };

  Instance.prototype.computeWarnings = function (role, width, height) {
    var warnings = [];
    if (width === null || height === null) { return warnings; }
    var target = TARGET[role];
    if (!target) { return warnings; }
    if (width < target.w || height < target.h) {
      warnings.push('Définition inférieure au format recommandé.');
    }
    var targetRatio = target.w / target.h;
    var ratio = width / height;
    var diff = Math.abs(ratio - targetRatio) / targetRatio;
    if (diff > RATIO_TOLERANCE) {
      warnings.push('Le cadrage diffère des proportions recommandées. L’atelier pourra vous recontacter.');
    }
    // pas plus de deux avertissements identiques (dédoublonnage simple)
    var seen = {}, out = [];
    for (var i = 0; i < warnings.length; i++) {
      if (!seen[warnings[i]]) { seen[warnings[i]] = true; out.push(warnings[i]); }
    }
    return out;
  };

  /* ---------- suppression ---------- */
  Instance.prototype.onDelete = function (role) {
    var slot = this.slots[role];
    if (!slot) { return; }
    this.slots[role] = { role: role, state: 'empty', wrap: slot.wrap, body: slot.body, addBtn: slot.addBtn };
    this.paintSlot(role);
    this.status('Photographie supprimée.');
    this.refreshConsentGate();
    this.updateSubmitButtonState();
    if (slot.addBtn && typeof slot.addBtn.focus === 'function') { slot.addBtn.focus(); }
  };

  /* ---------- changement de mode (1 <-> 2) ---------- */
  Instance.prototype.currentRadioMode = function () {
    for (var i = 0; i < this.compRadios.length; i++) {
      if (this.compRadios[i].checked) { return parseInt(this.compRadios[i].value, 10) || 0; }
    }
    return 0;
  };

  Instance.prototype.setRadioTo = function (mode) {
    for (var i = 0; i < this.compRadios.length; i++) {
      this.compRadios[i].checked = (parseInt(this.compRadios[i].value, 10) === mode);
    }
  };

  Instance.prototype.onCompositionChange = function () {
    var next = this.currentRadioMode();
    if (next === this.mode) { return; }
    if (!this.hasAnyFile()) {
      this.applyMode(next);
      return;
    }
    // Fichiers présents : ne pas changer silencieusement
    this.pendingMode = next;
    this.setRadioTo(this.mode); // restaurer visuellement le mode courant
    this.showModeConfirm();
  };

  Instance.prototype.showModeConfirm = function () {
    if (!this.confirmEl) { return; }
    this.confirmEl.hidden = false;
    var confirmBtn = this.confirmEl.querySelector('[data-pp-mode-confirm]');
    if (confirmBtn && typeof confirmBtn.focus === 'function') { confirmBtn.focus(); }
  };

  Instance.prototype.hideModeConfirm = function () {
    if (this.confirmEl) { this.confirmEl.hidden = true; }
  };

  Instance.prototype.confirmModeChange = function () {
    var target = this.pendingMode;
    this.clearAllSlots();
    this.hideModeConfirm();
    this.applyMode(target);
    this.setRadioTo(target);
    this.status('Nombre de photographies mis à jour. Les fichiers précédents ont été supprimés.');
  };

  Instance.prototype.cancelModeChange = function () {
    this.pendingMode = 0;
    this.hideModeConfirm();
    this.setRadioTo(this.mode);
    this.status('');
    for (var i = 0; i < this.compRadios.length; i++) {
      if (parseInt(this.compRadios[i].value, 10) === this.mode) {
        if (typeof this.compRadios[i].focus === 'function') { this.compRadios[i].focus(); }
        break;
      }
    }
  };

  Instance.prototype.clearAllSlots = function () {
    this.slots = {};
  };

  Instance.prototype.applyMode = function (mode) {
    this.mode = mode;
    this.pendingMode = 0;
    this.slots = {};
    this.renderSlots();
    this.updateSubmitButtonState();
  };

  /* ---------- consentement : empêcher le décochage si fichier prêt ---------- */
  Instance.prototype.onConsentChange = function () {
    if (!this.consentEl) { return; }
    if (!this.consentEl.checked && this.hasAnyFile()) {
      this.consentEl.checked = true;
      this.status('Supprimez les photographies ajoutées avant de retirer cette autorisation.');
      return;
    }
    this.refreshConsentGate();
    if (this.consentGiven()) { this.status(''); }
  };

  /* ============================================================
     12E-B — Formulaire dynamique local (compteurs, adresse, brouillon)
     ============================================================ */

  /* ---------- statut accessible du formulaire (distinct du statut upload) ---------- */
  Instance.prototype.formStatus = function (msg) {
    if (this.formStatusEl) { this.formStatusEl.textContent = msg || ''; }
  };

  /* ---------- compteurs de caractères ---------- */
  Instance.prototype.updateCounter = function (key) {
    var c = this.counters[key];
    if (!c || !c.el) { return; }
    var val = c.input ? c.input.value : '';
    var len = codePointLength(val);
    c.el.textContent = len + ' / ' + c.max;
    c.el.setAttribute('aria-label', len + ' caractères sur ' + c.max);
    c.el.classList.toggle('pp__counter--warning', len >= c.threshold);
  };
  Instance.prototype.updateAllCounters = function () {
    for (var key in this.counters) {
      if (Object.prototype.hasOwnProperty.call(this.counters, key)) { this.updateCounter(key); }
    }
  };

  /* ---------- lectures ponctuelles ---------- */
  Instance.prototype.currentSocle = function () {
    for (var i = 0; i < this.socleRadios.length; i++) {
      if (this.socleRadios[i].checked) { return this.socleRadios[i].value; }
    }
    return null;
  };
  Instance.prototype.selectedShipping = function () {
    for (var i = 0; i < this.shippingRadios.length; i++) {
      if (this.shippingRadios[i].checked) { return this.shippingRadios[i].value; }
    }
    return null;
  };
  Instance.prototype.setShippingTo = function (value) {
    for (var i = 0; i < this.shippingRadios.length; i++) {
      this.shippingRadios[i].checked = (this.shippingRadios[i].value === value);
    }
  };
  Instance.prototype.focusShipping = function (value) {
    for (var i = 0; i < this.shippingRadios.length; i++) {
      if (this.shippingRadios[i].value === value &&
          typeof this.shippingRadios[i].focus === 'function') {
        this.shippingRadios[i].focus();
        return;
      }
    }
  };

  /* ---------- client final : présence de données saisies ---------- */
  Instance.prototype.endCustomerHasData = function () {
    for (var i = 0; i < EC_FIELDS.length; i++) {
      var input = this.ecInputs[EC_FIELDS[i].key];
      if (input && String(input.value).trim() !== '') { return true; }
    }
    return false;
  };

  /* ---------- affichage / masquage du bloc client final ---------- */
  Instance.prototype.showEndCustomer = function (focusFirst) {
    if (!this.ecFieldset) { return; }
    this.ecFieldset.disabled = false;
    this.ecFieldset.hidden = false;
    for (var i = 0; i < EC_FIELDS.length; i++) {
      var input = this.ecInputs[EC_FIELDS[i].key];
      if (!input) { continue; }
      if (EC_FIELDS[i].required) {
        input.required = true;
        input.setAttribute('aria-required', 'true');
      }
    }
    this.syncEndCustomerState();
    this.formStatus('Les coordonnées du client final sont maintenant disponibles.');
    if (focusFirst) {
      var first = this.ecInputs.first_name;
      if (first && typeof first.focus === 'function') { first.focus(); }
    }
  };

  Instance.prototype.purgeEndCustomer = function () {
    for (var i = 0; i < EC_FIELDS.length; i++) {
      var key = EC_FIELDS[i].key;
      var input = this.ecInputs[key];
      if (input) {
        if (input.tagName === 'SELECT') { input.selectedIndex = 0; } else { input.value = ''; }
        input.required = false;
        input.removeAttribute('aria-required');
        input.removeAttribute('aria-invalid');
        input.classList.remove('pp__input--invalid');
      }
      this.showFieldError(key, null);
      this.formState.touched.delete(key);
    }
    if (this.ecFieldset) {
      this.ecFieldset.hidden = true;
      this.ecFieldset.disabled = true;
    }
    this.formState.endCustomer = null;
    if (this.errorSummaryEl) { this.errorSummaryEl.hidden = true; this.errorSummaryEl.innerHTML = ''; }
  };

  /* ---------- changement de destination ---------- */
  Instance.prototype.onShippingChange = function () {
    var val = this.selectedShipping();
    if (val === 'final_customer') {
      this.formState.shippingMode = 'final_customer';
      this.showEndCustomer(true);
    } else if (val === 'partner_address') {
      if (this.endCustomerHasData()) {
        // Ne pas perdre silencieusement : restaurer la radio et demander confirmation
        this.pendingShippingMode = 'partner_address';
        this.setShippingTo('final_customer');
        this.showDestinationConfirm();
      } else {
        this.formState.shippingMode = 'partner_address';
        this.purgeEndCustomer();
        this.formStatus('');
      }
    }
  };

  Instance.prototype.showDestinationConfirm = function () {
    if (!this.destConfirmEl) { return; }
    this.destConfirmEl.hidden = false;
    var btn = this.destConfirmEl.querySelector('[data-pp-destination-confirm]');
    if (btn && typeof btn.focus === 'function') { btn.focus(); }
  };
  Instance.prototype.hideDestinationConfirm = function () {
    if (this.destConfirmEl) { this.destConfirmEl.hidden = true; }
  };
  Instance.prototype.confirmDestinationChange = function () {
    this.purgeEndCustomer();
    this.setShippingTo('partner_address');
    this.formState.shippingMode = 'partner_address';
    this.pendingShippingMode = null;
    this.hideDestinationConfirm();
    this.formStatus('Coordonnées du client final supprimées. Livraison à l’adresse professionnelle sélectionnée.');
    this.focusShipping('partner_address');
  };
  Instance.prototype.cancelDestinationChange = function () {
    this.pendingShippingMode = null;
    this.setShippingTo('final_customer');
    this.formState.shippingMode = 'final_customer';
    this.hideDestinationConfirm();
    this.formStatus('');
    this.focusShipping('final_customer');
  };

  /* ---------- validation d'un champ client final ---------- */
  Instance.prototype.validateEcField = function (key) {
    var input = this.ecInputs[key];
    if (!input) { return null; }
    var conf = null;
    for (var i = 0; i < EC_FIELDS.length; i++) { if (EC_FIELDS[i].key === key) { conf = EC_FIELDS[i]; break; } }
    if (!conf) { return null; }
    var v = String(input.value).trim();

    if (key === 'address2') { return null; } // seul champ facultatif

    if (conf.required && v === '') {
      return { field: 'shipping.end_customer.' + key, code: 'required', message: 'Ce champ est obligatoire.', element: input };
    }
    if (v === '') { return null; }

    if (key === 'email') {
      var nativeBad = input.validity && input.validity.typeMismatch;
      if (nativeBad || !looksLikeEmail(v)) {
        return { field: 'shipping.end_customer.email', code: 'invalid_email', message: 'Saisissez une adresse e-mail valide.', element: input };
      }
    }
    if (key === 'phone') {
      if (phoneDigitCount(v) < 6) {
        return { field: 'shipping.end_customer.phone', code: 'invalid_phone', message: 'Indiquez un numéro de téléphone valide.', element: input };
      }
    }
    if (key === 'country') {
      if (EC_COUNTRIES.indexOf(v) === -1) {
        return { field: 'shipping.end_customer.country', code: 'invalid_country', message: 'Sélectionnez un pays.', element: input };
      }
    }
    return null;
  };

  Instance.prototype.showFieldError = function (key, err) {
    var errEl = this.ecErrors[key];
    var input = this.ecInputs[key];
    if (!errEl) { return; }
    if (err) {
      errEl.textContent = err.message;
      errEl.hidden = false;
      if (input) { input.setAttribute('aria-invalid', 'true'); input.classList.add('pp__input--invalid'); }
    } else {
      errEl.textContent = '';
      errEl.hidden = true;
      if (input) { input.removeAttribute('aria-invalid'); input.classList.remove('pp__input--invalid'); }
    }
  };

  Instance.prototype.syncEndCustomerState = function () {
    if (this.formState.shippingMode !== 'final_customer') { return; }
    var ec = {};
    for (var i = 0; i < EC_FIELDS.length; i++) {
      var k = EC_FIELDS[i].key;
      var input = this.ecInputs[k];
      ec[k] = input ? input.value : '';
    }
    this.formState.endCustomer = ec;
  };

  Instance.prototype.onEcBlur = function (key) {
    this.formState.touched.add(key);
    this.syncEndCustomerState();
    this.showFieldError(key, this.validateEcField(key));
  };
  Instance.prototype.onEcInput = function (key) {
    this.syncEndCustomerState();
    // Ne révèle une erreur que sur un champ déjà touché (jamais sur un champ vierge)
    if (this.formState.touched.has(key)) {
      this.showFieldError(key, this.validateEcField(key));
    }
  };

  /* ---------- validation globale (préparation ; ne débloque jamais le bouton) ---------- */
  Instance.prototype.validateRequestState = function (options) {
    options = options || {};
    var showAll = !!options.showAll;
    var errors = [];
    function push(field, code, message, element) {
      errors.push({ field: field, code: code, message: message, element: element || null });
    }

    if (this.mode !== 1 && this.mode !== 2) {
      push('composition', 'composition_required', 'Choisissez le nombre de photographies.', null);
    }
    if (!this.consentGiven()) {
      push('consents.production_rights', 'consent_required', 'Confirmez l’autorisation de traitement.', this.consentEl);
    }
    var roles = rolesForMode(this.mode);
    for (var r = 0; r < roles.length; r++) {
      var slot = this.slots[roles[r]];
      if (!slot || slot.state !== 'ready') {
        push('photos.' + roles[r], 'photo_required', 'Ajoutez la photographie requise.', null);
      }
    }
    if (!this.currentSocle()) {
      push('base_color', 'base_color_required', 'Choisissez la couleur du socle.', null);
    }
    var ship = this.selectedShipping();
    if (!ship) {
      push('shipping.mode', 'shipping_required', 'Choisissez une destination d’expédition.', null);
    }
    if (ship === 'final_customer') {
      for (var i = 0; i < EC_FIELDS.length; i++) {
        var err = this.validateEcField(EC_FIELDS[i].key);
        if (err) { push(err.field, err.code, err.message, err.element); }
      }
    }
    if (this.refInput && codePointLength(this.refInput.value) > COUNTER_CONF.partner_internal_reference.max) {
      push('partner_internal_reference', 'too_long', 'La référence dépasse 60 caractères.', this.refInput);
    }
    if (this.textInput && codePointLength(this.textInput.value) > COUNTER_CONF.text.max) {
      push('text', 'too_long', 'Le texte dépasse 50 caractères.', this.textInput);
    }
    if (this.instrInput && codePointLength(this.instrInput.value) > COUNTER_CONF.instructions.max) {
      push('instructions', 'too_long', 'Les instructions dépassent 250 caractères.', this.instrInput);
    }

    if (showAll) {
      if (ship === 'final_customer') {
        for (var t = 0; t < EC_FIELDS.length; t++) {
          var key = EC_FIELDS[t].key;
          this.formState.touched.add(key);
          this.showFieldError(key, this.validateEcField(key));
        }
      }
      this.renderErrorSummary(errors);
    }
    return { valid: errors.length === 0, errors: errors };
  };

  Instance.prototype.renderErrorSummary = function (errors) {
    if (!this.errorSummaryEl) { return; }
    this.errorSummaryEl.innerHTML = '';
    if (!errors || !errors.length) { this.errorSummaryEl.hidden = true; return; }
    var title = el('p', 'pp__error-summary-title');
    title.textContent = 'Vérifiez les informations suivantes :';
    this.errorSummaryEl.appendChild(title);
    var list = el('ul', 'pp__error-summary-list');
    for (var i = 0; i < errors.length; i++) {
      var li = el('li', 'pp__error-summary-item');
      if (errors[i].element && errors[i].element.id) {
        var a = el('a', 'pp__error-summary-link');
        a.href = '#' + errors[i].element.id;
        a.textContent = errors[i].message;
        (function (target) {
          a.addEventListener('click', function (ev) {
            ev.preventDefault();
            if (target && typeof target.focus === 'function') { target.focus(); }
          });
        })(errors[i].element);
        li.appendChild(a);
      } else {
        li.textContent = errors[i].message;
      }
      list.appendChild(li);
    }
    this.errorSummaryEl.appendChild(list);
    this.errorSummaryEl.hidden = false;
    if (typeof this.errorSummaryEl.focus === 'function') { this.errorSummaryEl.focus(); }
  };

  /* ---------- brouillon normalisé (pur : aucune écriture, aucun réseau, aucun log) ---------- */
  Instance.prototype.buildProfessionalRequestDraft = function () {
    var photos = [];
    var roles = rolesForMode(this.mode);
    for (var r = 0; r < roles.length; r++) {
      var slot = this.slots[roles[r]];
      if (!slot || slot.state !== 'ready') { continue; }
      photos.push({
        role: roles[r],
        uuid: slot.uuid ? slot.uuid : null,
        cdn_url: slot.cdnUrl ? slot.cdnUrl : null,
        name: slot.name ? slot.name : null,
        size_bytes: (typeof slot.size === 'number') ? slot.size : null,
        width: (typeof slot.width === 'number') ? slot.width : null,
        height: (typeof slot.height === 'number') ? slot.height : null
      });
    }

    var draft = {
      schema_version: 'pp-draft-v1',
      source: 'partner_portal',
      partner_internal_reference: trimOrNull(this.refInput ? this.refInput.value : ''),
      composition: (this.mode === 1 || this.mode === 2) ? this.mode : null,
      photos: photos,
      customization: {
        text: trimOrNull(this.textInput ? this.textInput.value : ''),
        instructions: trimOrNull(this.instrInput ? this.instrInput.value : '')
      },
      base_color: this.currentSocle(),
      shipping: {
        mode: this.selectedShipping(),
        end_customer: null
      },
      consents: {
        production_rights: this.consentGiven(),
        content_reuse: !!(this.contentReuseEl && this.contentReuseEl.checked)
      }
    };

    if (draft.shipping.mode === 'final_customer') {
      var g = this.ecInputs;
      draft.shipping.end_customer = {
        first_name: g.first_name ? String(g.first_name.value).trim() : '',
        last_name: g.last_name ? String(g.last_name.value).trim() : '',
        address1: g.address1 ? String(g.address1.value).trim() : '',
        address2: trimOrNull(g.address2 ? g.address2.value : ''),
        postal_code: g.postal_code ? String(g.postal_code.value).trim() : '',
        city: g.city ? String(g.city.value).trim() : '',
        country: g.country ? String(g.country.value).trim() : '',
        email: g.email ? String(g.email.value).trim() : '',
        phone: g.phone ? String(g.phone.value).trim() : ''
      };
    }
    return draft;
  };

  /* ============================================================
     EXPRESS-7B — Soumission contrôlée (POST réel App Proxy)
     ============================================================ */

  /* ---------- Uploadcare : tous les rôles requis sont prêts ---------- */
  Instance.prototype.uploadcareReady = function () {
    var roles = rolesForMode(this.mode);
    if (!roles.length) { return false; }
    for (var i = 0; i < roles.length; i++) {
      var slot = this.slots[roles[i]];
      if (!slot || slot.state !== 'ready') { return false; }
    }
    return true;
  };

  /* ---------- conditions d'activation du bouton (jamais autoritaire métier) ---------- */
  Instance.prototype.canSubmit = function () {
    if (this.submitting || this.submitted) { return false; }
    if (this.designMode) { return false; }
    // Formulaire réellement révélé (fail-closed : /me actif). Si un conteneur portail
    // existe, il doit être en état actif ; sinon (aperçu isolé) on ne bloque pas dessus.
    var portal = this.root.closest ? this.root.closest('[data-pp-root]') : null;
    if (portal && portal.getAttribute('data-pp-portal-state') !== 'active') { return false; }
    if (!this.consentGiven()) { return false; }
    if (!this.uploadcareReady()) { return false; }
    return this.validateRequestState({ showAll: false }).valid;
  };

  /* ---------- reflet visuel de l'état du bouton ---------- */
  Instance.prototype.updateSubmitButtonState = function () {
    if (!this.submitBtn) { return; }
    if (this.submitting) {
      this.submitBtn.disabled = true;
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('pp__button--disabled');
      this.submitBtn.textContent = 'Envoi en cours…';
      return;
    }
    if (this.submitted) {
      this.submitBtn.disabled = true;
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('pp__button--disabled');
      this.submitBtn.textContent = 'Demande envoyée';
      return;
    }
    var ok = this.canSubmit();
    this.submitBtn.disabled = !ok;
    this.submitBtn.setAttribute('aria-disabled', ok ? 'false' : 'true');
    this.submitBtn.classList.toggle('pp__button--disabled', !ok);
    this.submitBtn.textContent = this.submitBtnDefaultLabel;
  };

  /* ---------- messages d'erreur serveur / réseau (bloc global) ---------- */
  Instance.prototype.showSubmitError = function (msg) {
    if (!this.submitErrorEl) { this.formStatus(msg || ''); return; }
    if (!msg) {
      this.submitErrorEl.hidden = true;
      this.submitErrorEl.textContent = '';
      return;
    }
    this.submitErrorEl.textContent = msg;
    this.submitErrorEl.hidden = false;
    if (typeof this.submitErrorEl.focus === 'function') { this.submitErrorEl.focus(); }
  };
  Instance.prototype.clearSubmitError = function () { this.showSubmitError(null); };

  /* ---------- signature simple du payload (détection de changement) ---------- */
  Instance.prototype.payloadSignature = function (payload) {
    try { return JSON.stringify(payload); } catch (e) { return null; }
  };

  /* ---------- Idempotency-Key : réutilisée si même payload, régénérée sinon ---------- */
  Instance.prototype.ensureIdempotencyKey = function (signature) {
    if (!this.idempotencyKey || this.idempotencyPayloadSignature !== signature) {
      this.idempotencyKey = uuidV4();
      this.idempotencyPayloadSignature = signature;
    }
    return this.idempotencyKey;
  };

  /* ---------- lecture tolérante du corps JSON (jamais bloquant) ---------- */
  function readJsonSafe(res) {
    return res.json().then(function (d) { return d; }, function () { return null; });
  }

  /* ---------- mapper 422 tolérant (tableau, objet Laravel, fallback) ---------- */
  /* Retourne { fieldErrors: [{field, code, message}], uploadIssue: bool, generic: string|null } */
  function normalize422(body) {
    var out = { fieldErrors: [], uploadIssue: false, generic: null };
    var UPLOAD_CODES = ['upload_unreachable', 'upload_invalid_host', 'upload_invalid_type', 'upload_too_large'];
    if (body && body.errors) {
      if (Object.prototype.toString.call(body.errors) === '[object Array]') {
        for (var i = 0; i < body.errors.length; i++) {
          var e = body.errors[i] || {};
          var fe = { field: e.field || null, code: e.code || null, message: e.message || 'Champ invalide.' };
          out.fieldErrors.push(fe);
          if ((fe.code && UPLOAD_CODES.indexOf(fe.code) !== -1) ||
              (fe.field && fe.field.indexOf('photos') === 0)) { out.uploadIssue = true; }
        }
      } else if (typeof body.errors === 'object') {
        // Format Laravel : { "field": ["message", ...] }
        for (var key in body.errors) {
          if (!Object.prototype.hasOwnProperty.call(body.errors, key)) { continue; }
          var arr = body.errors[key];
          var msg = (Object.prototype.toString.call(arr) === '[object Array]' && arr.length) ? String(arr[0]) : String(arr);
          out.fieldErrors.push({ field: key, code: null, message: msg });
          if (key.indexOf('photos') === 0) { out.uploadIssue = true; }
        }
      }
    }
    if (!out.fieldErrors.length) {
      out.generic = (body && (body.error || body.message)) ? String(body.error || body.message) : null;
    }
    return out;
  }

  /* ---------- résolution d'un champ backend vers un champ client final ---------- */
  Instance.prototype.ecKeyFromField = function (field) {
    if (!field || field.indexOf('shipping.end_customer.') !== 0) { return null; }
    var key = field.slice('shipping.end_customer.'.length);
    return this.ecInputs[key] ? key : null;
  };

  /* ---------- application d'un 422 sur l'UI existante ---------- */
  Instance.prototype.apply422 = function (body) {
    var norm = normalize422(body);
    var summary = [];
    for (var i = 0; i < norm.fieldErrors.length; i++) {
      var fe = norm.fieldErrors[i];
      var ecKey = this.ecKeyFromField(fe.field);
      if (ecKey) {
        this.formState.touched.add(ecKey);
        this.showFieldError(ecKey, { message: fe.message });
        var input = this.ecInputs[ecKey];
        summary.push({ field: fe.field, code: fe.code, message: fe.message, element: input || null });
      } else {
        summary.push({ field: fe.field, code: fe.code, message: fe.message, element: null });
      }
    }
    if (summary.length) { this.renderErrorSummary(summary); }
    if (norm.uploadIssue) {
      this.showSubmitError('La photographie n’est plus accessible. Supprimez-la puis téléversez-la de nouveau.');
    } else if (norm.generic) {
      this.showSubmitError(norm.generic);
    } else if (!summary.length) {
      this.showSubmitError('Certaines informations sont invalides. Vérifiez le formulaire.');
    } else {
      this.clearSubmitError();
    }
  };

  /* ---------- affichage du succès (référence serveur uniquement) ---------- */
  Instance.prototype.showSuccess = function (data, replay) {
    var d = data || {};
    if (this.successEl) {
      var titleEl = this.successEl.querySelector('[data-pp-success-title]');
      var refEl = this.successEl.querySelector('[data-pp-success-reference]');
      var statusRow = this.successEl.querySelector('[data-pp-success-status-row]');
      var statusEl = this.successEl.querySelector('[data-pp-success-status]');
      var dateRow = this.successEl.querySelector('[data-pp-success-date-row]');
      var dateEl = this.successEl.querySelector('[data-pp-success-date]');
      if (titleEl) { titleEl.textContent = replay ? 'Demande déjà enregistrée' : 'Demande envoyée'; }
      if (refEl) { refEl.textContent = d.professional_request_reference ? String(d.professional_request_reference) : '—'; }
      if (statusEl && statusRow) {
        if (d.status) { statusEl.textContent = histStatusLabel(d.status); statusRow.hidden = false; }
        else { statusRow.hidden = true; }
      }
      if (dateEl && dateRow) {
        if (d.submitted_at) { dateEl.textContent = histFormatDate(d.submitted_at); dateRow.hidden = false; }
        else { dateRow.hidden = true; }
      }
      this.successEl.hidden = false;
      if (typeof this.successEl.focus === 'function') { this.successEl.focus(); }
    }
    this.clearSubmitError();
    if (this.errorSummaryEl) { this.errorSummaryEl.hidden = true; this.errorSummaryEl.innerHTML = ''; }
    this.submitted = true;
    this.submitting = false;
    this.updateSubmitButtonState();

    // Rafraîchit l'historique pour refléter la demande créée. Encapsulé : un échec
    // du rafraîchissement ne masque jamais le succès affiché ci-dessus. Aucune seconde
    // soumission possible (this.submitted = true → bouton désactivé).
    try {
      var portalRoot = this.root && this.root.closest ? this.root.closest('[data-pp-root]') : null;
      var histHost = portalRoot ? portalRoot.querySelector('[data-pp-history]') : null;
      if (histHost && typeof histHost.__ppHistoryRefresh === 'function') { histHost.__ppHistoryRefresh(); }
    } catch (e) { /* rafraîchissement best-effort : le succès reste affiché */ }
  };

  /* ---------- fin d'une tentative récupérable (réactive le bouton) ---------- */
  Instance.prototype.endRecoverable = function () {
    this.submitting = false;
    this.updateSubmitButtonState();
  };

  /* ---------- soumission principale ---------- */
  Instance.prototype.onSubmit = function () {
    if (this.submitting || this.submitted) { return; }

    var check = this.validateRequestState({ showAll: true });
    if (!check.valid) {
      this.showSubmitError('Vérifiez les informations avant l’envoi.');
      return;
    }
    if (!this.uploadcareReady()) {
      this.showSubmitError('Ajoutez la ou les photographies requises avant l’envoi.');
      return;
    }

    var payload = this.buildProfessionalRequestDraft();
    var signature = this.payloadSignature(payload);
    var key = this.ensureIdempotencyKey(signature);
    if (!key) {
      this.showSubmitError('Impossible de préparer l’envoi sécurisé sur ce navigateur. Réessayez.');
      return;
    }

    this.clearSubmitError();
    this.submitting = true;
    this.updateSubmitButtonState();

    var self = this;
    window.fetch(SUBMIT_ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Idempotency-Key': key
      },
      body: JSON.stringify(payload)
    }).then(function (res) {
      var status = res ? res.status : 0;
      if (status === 201) {
        return readJsonSafe(res).then(function (d) { self.showSuccess(d, false); });
      }
      if (status === 200) {
        return readJsonSafe(res).then(function (d) { self.showSuccess(d, true); });
      }
      if (status === 409) {
        self.showSubmitError('Cette tentative d’envoi est en conflit. Rechargez la page avant de réessayer.');
        self.submitting = false;
        self.updateSubmitButtonState();
        return;
      }
      if (status === 422) {
        return readJsonSafe(res).then(function (d) {
          self.apply422(d);
          self.endRecoverable();
        });
      }
      if (status === 429) {
        self.showSubmitError('Trop de tentatives. Patientez quelques instants avant de réessayer.');
        self.endRecoverable();
        return;
      }
      if (status === 401) {
        self.showSubmitError('Votre session a expiré. Reconnectez-vous pour envoyer votre demande.');
        self.submitting = false;
        self.updateSubmitButtonState();
        return;
      }
      if (status === 403) {
        // Partenaire non autorisé / inactif → fail-closed comme /me.
        var portal = self.root.closest ? self.root.closest('[data-pp-root]') : null;
        if (portal) { authFailClosed(portal); }
        self.showSubmitError('Votre accès partenaire n’est pas actif. Contactez notre équipe.');
        self.submitting = false;
        return;
      }
      // 500 et autres statuts serveur : retry autorisé avec la même clé (payload identique).
      self.showSubmitError('Le service est momentanément indisponible. Réessayez dans quelques instants.');
      self.endRecoverable();
    }).catch(function () {
      // Erreur réseau : retry autorisé avec la même clé si le payload ne change pas.
      self.showSubmitError('Connexion interrompue. Vérifiez votre réseau puis réessayez.');
      self.endRecoverable();
    });
  };

  /* ---------- init d'une racine ---------- */
  Instance.prototype.init = function () {
    var self = this;

    // Composition
    for (var i = 0; i < this.compRadios.length; i++) {
      this.compRadios[i].addEventListener('change', function () {
        self.onCompositionChange();
        self.updateSubmitButtonState();
      });
    }
    // Consentement obligatoire
    if (this.consentEl) {
      this.consentEl.addEventListener('change', function () {
        self.onConsentChange();
        self.formState.productionRightsConsent = self.consentGiven();
        self.updateSubmitButtonState();
      });
    }
    // Confirmation de changement de mode
    if (this.confirmEl) {
      var cok = this.confirmEl.querySelector('[data-pp-mode-confirm]');
      var cno = this.confirmEl.querySelector('[data-pp-mode-cancel]');
      if (cok) { cok.addEventListener('click', function () { self.confirmModeChange(); }); }
      if (cno) { cno.addEventListener('click', function () { self.cancelModeChange(); }); }
    }

    // Compteurs de caractères
    if (this.refInput) {
      this.refInput.addEventListener('input', function () {
        self.updateCounter('partner_internal_reference');
        self.formState.partnerInternalReference = self.refInput.value;
        self.updateSubmitButtonState();
      });
    }
    if (this.textInput) {
      this.textInput.addEventListener('input', function () {
        self.updateCounter('text');
        self.formState.text = self.textInput.value;
        self.updateSubmitButtonState();
      });
    }
    if (this.instrInput) {
      this.instrInput.addEventListener('input', function () {
        self.updateCounter('instructions');
        self.formState.instructions = self.instrInput.value;
        self.updateSubmitButtonState();
      });
    }

    // Couleur du socle
    for (var s = 0; s < this.socleRadios.length; s++) {
      this.socleRadios[s].addEventListener('change', function () {
        self.formState.baseColor = self.currentSocle();
        self.updateSubmitButtonState();
      });
    }

    // Destination d'expédition
    for (var d = 0; d < this.shippingRadios.length; d++) {
      this.shippingRadios[d].addEventListener('change', function () {
        self.onShippingChange();
        self.updateSubmitButtonState();
      });
    }
    // Confirmation de changement de destination
    if (this.destConfirmEl) {
      var dok = this.destConfirmEl.querySelector('[data-pp-destination-confirm]');
      var dno = this.destConfirmEl.querySelector('[data-pp-destination-cancel]');
      if (dok) { dok.addEventListener('click', function () { self.confirmDestinationChange(); }); }
      if (dno) { dno.addEventListener('click', function () { self.cancelDestinationChange(); }); }
    }

    // Consentement facultatif
    if (this.contentReuseEl) {
      this.contentReuseEl.addEventListener('change', function () {
        self.formState.contentReuseConsent = !!self.contentReuseEl.checked;
      });
    }

    // Consentement facultatif (mis à jour du bouton pour cohérence, sans le conditionner)
    if (this.contentReuseEl) {
      this.contentReuseEl.addEventListener('change', function () {
        self.updateSubmitButtonState();
      });
    }

    // Champs client final (input + change + blur)
    for (var e = 0; e < EC_FIELDS.length; e++) {
      (function (key) {
        var input = self.ecInputs[key];
        if (!input) { return; }
        input.addEventListener('input', function () { self.onEcInput(key); self.updateSubmitButtonState(); });
        input.addEventListener('change', function () { self.onEcInput(key); self.updateSubmitButtonState(); });
        input.addEventListener('blur', function () { self.onEcBlur(key); self.updateSubmitButtonState(); });
      })(EC_FIELDS[e].key);
    }

    // Soumission : POST réel via App Proxy (jamais d'envoi natif Shopify)
    if (this.submitBtn) {
      this.submitBtn.addEventListener('click', function (ev) {
        ev.preventDefault();
        self.onSubmit();
      });
    }
    if (this.form) {
      this.form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        self.onSubmit();
      });
    }

    // État initial
    this.mode = this.currentRadioMode();
    this.formState.shippingMode = this.selectedShipping();
    this.formState.baseColor = this.currentSocle();
    this.formState.productionRightsConsent = this.consentGiven();
    this.formState.contentReuseConsent = !!(this.contentReuseEl && this.contentReuseEl.checked);
    this.updateAllCounters();
    this.renderSlots();
    this.updateSubmitButtonState();
  };

  /* ---------- bootstrap ---------- */
  function initRoot(root) {
    if (!root || root.getAttribute('data-pp-initialized') === 'true') { return; }
    root.setAttribute('data-pp-initialized', 'true');
    var inst = new Instance(root);
    PP.instances.set(root, inst);
    inst.init();
  }

  function initAll(scope) {
    var ctx = scope && scope.querySelectorAll ? scope : document;
    // 1. Identité PHO (EXPRESS-5) : révèle le formulaire fail-closed après /me actif.
    var authRoots = ctx.querySelectorAll('[data-pp-root]');
    for (var a = 0; a < authRoots.length; a++) { initAuth(authRoots[a]); }
    // 2. Formulaire (Uploadcare / brouillon / validation locale).
    var roots = ctx.querySelectorAll('[data-pp-request]');
    for (var i = 0; i < roots.length; i++) { initRoot(roots[i]); }
  }

  /* ---------- EXPRESS-5 : identité PHO réelle via App Proxy signé (fail-closed) ----------
     Appelle GET <data-pp-me-endpoint> (défaut /apps/partner-portal/me). N'accepte QUE
     HTTP 200 + JSON { first_name, company_name, partner_code, partner_status } avec
     partner_status === 'active'. Toute autre issue (401/403/404/500, réseau, JSON
     invalide, clé manquante, statut non actif) = fail-closed : identité et formulaire
     masqués. Aucune confiance navigateur, aucun stockage (localStorage/sessionStorage),
     aucun token, aucune réactivation du bouton d'envoi. Une seule requête par section. */
  var PP_STATUS_LABELS = { active: 'Actif' };

  function ppShow(el) { if (el) { el.hidden = false; } }
  function ppHide(el) { if (el) { el.hidden = true; } }
  function ppSetText(root, sel, value) {
    var el = root.querySelector(sel);
    // textContent uniquement : aucune injection HTML possible.
    if (el) { el.textContent = (value == null) ? '' : String(value); }
  }

  function authFailClosed(root) {
    root.setAttribute('data-pp-portal-state', 'denied');
    ppHide(root.querySelector('[data-pp-auth-loading]'));
    ppHide(root.querySelector('[data-pp-identity]'));
    ppHide(root.querySelector('[data-pp-portal-form]'));
    ppShow(root.querySelector('[data-pp-auth-error]'));
    // Le bouton d'envoi reste désactivé : jamais réactivé ici.
  }

  function authRevealActive(root, data) {
    ppSetText(root, '[data-pp-first-name]', data.first_name);
    ppSetText(root, '[data-pp-company-name]', data.company_name);
    ppSetText(root, '[data-pp-partner-code]', data.partner_code);
    ppSetText(root, '[data-pp-partner-status]', PP_STATUS_LABELS[data.partner_status] || data.partner_status);
    ppHide(root.querySelector('[data-pp-auth-loading]'));
    ppHide(root.querySelector('[data-pp-auth-error]'));
    ppShow(root.querySelector('[data-pp-identity]'));
    ppShow(root.querySelector('[data-pp-portal-form]'));
    root.setAttribute('data-pp-portal-state', 'active');
    // Le formulaire devient visible : on l'initialise (idempotent) pour Uploadcare/brouillon/validation.
    var form = root.querySelector('[data-pp-request]');
    if (form) { initRoot(form); }
    // Le bouton d'envoi reste désactivé (EXPRESS-5 ne l'active pas).
    // EXPRESS-8C — Historique PHO (lecture seule) : révélé + initialisé UNIQUEMENT ici,
    // après confirmation serveur 200 + active. Jamais chargé sinon.
    var history = root.querySelector('[data-pp-history]');
    if (history) { ppShow(history); initHistory(root); }
  }

  function isValidMePayload(d) {
    if (!d || typeof d !== 'object') { return false; }
    var keys = ['first_name', 'company_name', 'partner_code', 'partner_status'];
    for (var k = 0; k < keys.length; k++) {
      if (typeof d[keys[k]] !== 'string' || d[keys[k]] === '') { return false; }
    }
    // Les clés supplémentaires éventuelles sont ignorées (jamais consommées).
    return d.partner_status === 'active';
  }

  function initAuth(root) {
    if (!root || root.getAttribute('data-pp-auth-initialized') === 'true') { return; }
    root.setAttribute('data-pp-auth-initialized', 'true');
    root.setAttribute('data-pp-portal-state', 'loading');

    var endpoint = root.getAttribute('data-pp-me-endpoint') || '/apps/partner-portal/me';
    if (typeof window.fetch !== 'function') { authFailClosed(root); return; }

    window.fetch(endpoint, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    }).then(function (res) {
      if (!res || res.status !== 200) { authFailClosed(root); return; }
      return res.json().then(function (data) {
        if (isValidMePayload(data)) { authRevealActive(root, data); }
        else { authFailClosed(root); }
      }).catch(function () { authFailClosed(root); });
    }).catch(function () { authFailClosed(root); });
  }

  /* ============================================================
     EXPRESS-8C — Historique PHO (lecture seule)
     Module SÉPARÉ du formulaire. Aucune écriture, aucun POST, aucun stockage.
     Rendu 100 % via createElement/textContent (jamais innerHTML avec contenu serveur).
     Le navigateur n'est jamais autoritaire : le statut affiché n'ouvre aucun droit.
     ============================================================ */
  var HIST_STATUS_LABELS = {
    submitted: 'Demande envoyée',
    under_review: 'En cours d’étude',
    needs_information: 'Complément demandé',
    accepted: 'Demande acceptée',
    approved: 'Demande acceptée',
    refused: 'Demande refusée',
    rejected: 'Demande refusée',
    cancelled: 'Annulée'
  };
  var HIST_DESTINATION_LABELS = {
    partner_address: 'À mon adresse professionnelle',
    final_customer: 'Directement chez mon client'
  };
  var HIST_COMPOSITION_LABELS = { '1': '1 photo', '2': '2 photos', 1: '1 photo', 2: '2 photos' };
  var HIST_PHOTO_ROLE_LABELS = {
    panoramic: 'Photo panoramique',
    front: 'Face avant',
    back: 'Face arrière'
  };

  function histStatusLabel(s) {
    if (s == null) { return '—'; }
    return HIST_STATUS_LABELS[s] || String(s);
  }
  function histIsHttps(url) {
    return typeof url === 'string' && url.indexOf('https://') === 0;
  }
  function histText(v) {
    if (v === null || v === undefined) { return ''; }
    return String(v);
  }

  /* Formatage FR lisible d'une date serveur ISO. La valeur serveur reste la source :
     en cas d'échec de parse ou d'absence d'Intl, on retombe sur le texte brut. */
  var HIST_MONTHS_FR = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin',
    'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  function histFormatDate(v) {
    var raw = histText(v);
    if (!raw) { return ''; }
    var d = new Date(raw);
    if (isNaN(d.getTime())) { return raw; }
    try {
      var fmt = new Intl.DateTimeFormat('fr-FR', {
        timeZone: 'Europe/Paris',
        day: 'numeric', month: 'long', year: 'numeric',
        hour: '2-digit', minute: '2-digit', hour12: false
      });
      var parts = {};
      var arr = fmt.formatToParts(d);
      for (var i = 0; i < arr.length; i++) { parts[arr[i].type] = arr[i].value; }
      if (parts.day && parts.month && parts.year && parts.hour && parts.minute) {
        return parts.day + ' ' + parts.month + ' ' + parts.year + ' à ' + parts.hour + ':' + parts.minute;
      }
    } catch (e) { /* Intl/timeZone indisponible : fallback local ci-dessous */ }
    // Fallback sans fuseau explicite (heure locale du navigateur).
    var mo = HIST_MONTHS_FR[d.getMonth()] || '';
    var hh = ('0' + d.getHours()).slice(-2);
    var mm = ('0' + d.getMinutes()).slice(-2);
    return d.getDate() + ' ' + mo + ' ' + d.getFullYear() + ' à ' + hh + ':' + mm;
  }

  /* Extraction tolérante d'un tableau d'items depuis diverses formes de réponse. */
  function histExtractItems(body) {
    if (!body) { return []; }
    if (Object.prototype.toString.call(body) === '[object Array]') { return body; }
    var candidates = ['data', 'requests', 'professional_requests', 'items', 'results'];
    for (var i = 0; i < candidates.length; i++) {
      if (Object.prototype.toString.call(body[candidates[i]]) === '[object Array]') {
        return body[candidates[i]];
      }
    }
    return [];
  }
  function histNum(v, dflt) {
    var n = parseInt(v, 10);
    return isNaN(n) ? dflt : n;
  }
  /* Nombre de pages : tolérant (total_pages / last_page, sinon dérivé de total/per_page). */
  function histTotalPages(body, perPage, itemsLen) {
    if (!body) { return 1; }
    var tp = body.total_pages || body.last_page || (body.meta && (body.meta.total_pages || body.meta.last_page));
    tp = histNum(tp, 0);
    if (tp > 0) { return tp; }
    var total = histNum(body.total || (body.meta && body.meta.total), 0);
    if (total > 0 && perPage > 0) { return Math.max(1, Math.ceil(total / perPage)); }
    // Fallback : au moins la page courante ; une page pleine suggère une suivante possible.
    return (itemsLen >= perPage) ? 0 : 1; // 0 = inconnu (bouton suivant géré séparément)
  }
  function histPhotosCount(item) {
    if (typeof item.photos_count === 'number') { return item.photos_count; }
    if (Object.prototype.toString.call(item.photos) === '[object Array]') { return item.photos.length; }
    var c = histNum(item.composition, 0);
    return c > 0 ? c : null;
  }

  function initHistory(root) {
    var host = root.querySelector('[data-pp-history]');
    if (!host || host.getAttribute('data-pp-history-initialized') === 'true') { return; }
    host.setAttribute('data-pp-history-initialized', 'true');

    var endpoint = host.getAttribute('data-pp-history-endpoint') || '/apps/partner-portal/professional-requests';
    var perPage = histNum(host.getAttribute('data-pp-history-per-page'), 20);
    if (perPage <= 0) { perPage = 20; }

    var ctrl = {
      host: host,
      endpoint: endpoint,
      perPage: perPage,
      currentPage: 1,
      totalPages: 0,
      loadingList: false,
      loadingDetail: false,
      listEl: host.querySelector('[data-pp-history-list]'),
      loadingEl: host.querySelector('[data-pp-history-loading]'),
      emptyEl: host.querySelector('[data-pp-history-empty]'),
      errorEl: host.querySelector('[data-pp-history-error]'),
      paginationEl: host.querySelector('[data-pp-history-pagination]'),
      pageLabelEl: host.querySelector('[data-pp-history-page]'),
      prevBtn: host.querySelector('[data-pp-history-prev]'),
      nextBtn: host.querySelector('[data-pp-history-next]'),
      refreshBtn: host.querySelector('[data-pp-history-refresh]'),
      detailEl: host.querySelector('[data-pp-history-detail]'),
      detailBodyEl: host.querySelector('[data-pp-history-detail-body]'),
      detailCloseBtn: host.querySelector('[data-pp-history-detail-close]')
    };

    if (ctrl.refreshBtn) {
      ctrl.refreshBtn.addEventListener('click', function () { histFetchList(ctrl, ctrl.currentPage); });
    }
    if (ctrl.prevBtn) {
      ctrl.prevBtn.addEventListener('click', function () {
        if (ctrl.currentPage > 1) { histFetchList(ctrl, ctrl.currentPage - 1); }
      });
    }
    if (ctrl.nextBtn) {
      ctrl.nextBtn.addEventListener('click', function () {
        histFetchList(ctrl, ctrl.currentPage + 1);
      });
    }
    if (ctrl.detailCloseBtn) {
      ctrl.detailCloseBtn.addEventListener('click', function () { histCloseDetail(ctrl); });
    }

    // Déclencheur exposé : rafraîchit la liste (page 1) via la fonction fetch existante.
    // Utilisé après une soumission réussie pour refléter la nouvelle demande sans
    // rechargement de page. Réutilise histFetchList (aucun nouveau chemin réseau).
    host.__ppHistoryRefresh = function () { histFetchList(ctrl, 1); };

    histFetchList(ctrl, 1);
  }

  function histSetHidden(el, hidden) { if (el) { el.hidden = !!hidden; } }

  function histShowError(ctrl, msg) {
    if (ctrl.errorEl) {
      ctrl.errorEl.textContent = msg || '';
      ctrl.errorEl.hidden = !msg;
    }
  }

  function histMessageForStatus(status, isDetail) {
    if (status === 401 || status === 403) { return 'Votre accès partenaire n’est pas disponible.'; }
    if (status === 404 && isDetail) { return 'Demande introuvable.'; }
    if (status === 429) { return 'Trop de requêtes, réessayez dans un instant.'; }
    return isDetail
      ? 'Impossible de charger cette demande pour le moment.'
      : 'Impossible de charger vos demandes pour le moment.';
  }

  function histFetchList(ctrl, page) {
    if (ctrl.loadingList) { return; }
    if (page < 1) { page = 1; }
    ctrl.loadingList = true;
    histShowError(ctrl, null);
    histSetHidden(ctrl.emptyEl, true);
    histSetHidden(ctrl.loadingEl, false);
    histCloseDetail(ctrl);

    var url = ctrl.endpoint + '?page=' + encodeURIComponent(page) + '&per_page=' + encodeURIComponent(ctrl.perPage);
    window.fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    }).then(function (res) {
      var status = res ? res.status : 0;
      if (status !== 200) {
        histSetHidden(ctrl.loadingEl, true);
        ctrl.loadingList = false;
        histShowError(ctrl, histMessageForStatus(status, false));
        return;
      }
      return res.json().then(function (body) {
        histSetHidden(ctrl.loadingEl, true);
        ctrl.loadingList = false;
        var items = histExtractItems(body);
        var serverPage = histNum(body && (body.page || body.current_page || (body.meta && body.meta.current_page)), page);
        ctrl.currentPage = serverPage > 0 ? serverPage : page;
        ctrl.totalPages = histTotalPages(body, ctrl.perPage, items.length);
        histRenderList(ctrl, items);
      }, function () {
        histSetHidden(ctrl.loadingEl, true);
        ctrl.loadingList = false;
        histShowError(ctrl, histMessageForStatus(0, false));
      });
    }).catch(function () {
      histSetHidden(ctrl.loadingEl, true);
      ctrl.loadingList = false;
      histShowError(ctrl, histMessageForStatus(0, false));
    });
  }

  function histRenderList(ctrl, items) {
    if (!ctrl.listEl) { return; }
    ctrl.listEl.textContent = '';
    if (!items || !items.length) {
      histSetHidden(ctrl.emptyEl, false);
      histSetHidden(ctrl.paginationEl, true);
      return;
    }
    histSetHidden(ctrl.emptyEl, true);

    for (var i = 0; i < items.length; i++) {
      ctrl.listEl.appendChild(histBuildListItem(ctrl, items[i]));
    }
    histRenderPagination(ctrl, items.length);
  }

  function histBuildListItem(ctrl, item) {
    var ref = histText(item.professional_request_reference || item.reference);
    var li = document.createElement('li');
    li.className = 'pp__history-item';

    var main = document.createElement('div');
    main.className = 'pp__history-item-main';

    var refEl = document.createElement('p');
    refEl.className = 'pp__history-item-ref';
    refEl.textContent = ref || '—';
    main.appendChild(refEl);

    var badges = document.createElement('div');
    badges.className = 'pp__history-badges';
    var statusBadge = document.createElement('span');
    statusBadge.className = 'pp__history-badge pp__history-badge--status';
    statusBadge.textContent = histStatusLabel(item.status);
    badges.appendChild(statusBadge);
    if (item.needs_attention === true) {
      var attn = document.createElement('span');
      attn.className = 'pp__history-badge pp__history-badge--attention';
      attn.textContent = 'Action requise';
      badges.appendChild(attn);
    }
    main.appendChild(badges);

    var meta = document.createElement('p');
    meta.className = 'pp__history-item-meta';
    var parts = [];
    var submitted = item.submitted_at || item.created_at;
    if (submitted) { parts.push('Envoyée le ' + histFormatDate(submitted)); }
    var pc = histPhotosCount(item);
    if (pc !== null) { parts.push(pc + (pc > 1 ? ' photos' : ' photo')); }
    var destLabel = item.shipping && item.shipping.mode ? HIST_DESTINATION_LABELS[item.shipping.mode] : null;
    if (destLabel) { parts.push(destLabel); }
    meta.textContent = parts.join(' · ');
    if (parts.length) { main.appendChild(meta); }

    li.appendChild(main);

    var actions = document.createElement('div');
    actions.className = 'pp__history-item-actions';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pp__button pp__button--ghost';
    btn.textContent = 'Voir le détail';
    if (ref) {
      btn.addEventListener('click', function () { histFetchDetail(ctrl, ref); });
    } else {
      btn.disabled = true;
    }
    actions.appendChild(btn);
    li.appendChild(actions);

    return li;
  }

  function histRenderPagination(ctrl, itemsLen) {
    if (!ctrl.paginationEl) { return; }
    var hasPrev = ctrl.currentPage > 1;
    var hasNext;
    if (ctrl.totalPages > 0) {
      hasNext = ctrl.currentPage < ctrl.totalPages;
    } else {
      // Nombre de pages inconnu : proposer "suivant" si la page est pleine.
      hasNext = itemsLen >= ctrl.perPage;
    }
    if (!hasPrev && !hasNext) {
      histSetHidden(ctrl.paginationEl, true);
      return;
    }
    histSetHidden(ctrl.paginationEl, false);
    if (ctrl.prevBtn) { ctrl.prevBtn.disabled = !hasPrev; }
    if (ctrl.nextBtn) { ctrl.nextBtn.disabled = !hasNext; }
    if (ctrl.pageLabelEl) {
      ctrl.pageLabelEl.textContent = ctrl.totalPages > 0
        ? ('Page ' + ctrl.currentPage + ' sur ' + ctrl.totalPages)
        : ('Page ' + ctrl.currentPage);
    }
  }

  function histCloseDetail(ctrl) {
    if (ctrl.detailEl) { ctrl.detailEl.hidden = true; }
    if (ctrl.detailBodyEl) { ctrl.detailBodyEl.textContent = ''; }
    if (ctrl.listEl) { ctrl.listEl.hidden = false; }
    if (ctrl.paginationEl && (ctrl.currentPage > 1 || ctrl.totalPages > 1 || ctrl.totalPages === 0)) {
      // La visibilité réelle est régie par histRenderPagination ; on laisse l'état courant.
    }
  }

  function histFetchDetail(ctrl, reference) {
    if (ctrl.loadingDetail) { return; }
    ctrl.loadingDetail = true;
    histShowError(ctrl, null);

    var url = ctrl.endpoint + '/' + encodeURIComponent(reference);
    window.fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    }).then(function (res) {
      var status = res ? res.status : 0;
      if (status !== 200) {
        ctrl.loadingDetail = false;
        histShowError(ctrl, histMessageForStatus(status, true));
        return;
      }
      return res.json().then(function (body) {
        ctrl.loadingDetail = false;
        histRenderDetail(ctrl, body);
      }, function () {
        ctrl.loadingDetail = false;
        histShowError(ctrl, histMessageForStatus(0, true));
      });
    }).catch(function () {
      ctrl.loadingDetail = false;
      histShowError(ctrl, histMessageForStatus(0, true));
    });
  }

  /* Petite fabrique : ligne "terme / valeur" (jamais innerHTML). */
  function histDefRow(term, value) {
    var row = document.createElement('div');
    row.className = 'pp__history-detail-row';
    var dt = document.createElement('span');
    dt.className = 'pp__history-detail-term';
    dt.textContent = term;
    var dd = document.createElement('span');
    dd.className = 'pp__history-detail-value';
    dd.textContent = value;
    row.appendChild(dt);
    row.appendChild(dd);
    return row;
  }

  function histRenderDetail(ctrl, data) {
    if (!ctrl.detailBodyEl || !ctrl.detailEl) { return; }
    var d = data && typeof data === 'object' ? (data.data && typeof data.data === 'object' ? data.data : data) : {};
    var body = ctrl.detailBodyEl;
    body.textContent = '';

    var ref = histText(d.professional_request_reference || d.reference);
    var title = document.createElement('h3');
    title.className = 'pp__history-detail-title';
    title.textContent = ref || 'Demande';
    body.appendChild(title);

    // Bloc "Action requise" : affiché en tête si le serveur signale un complément
    // (statut needs_information) ou fournit un objet action_required.
    // Rendu 100 % textContent : le motif serveur n'est jamais interprété comme HTML.
    var actionReq = (d.action_required && typeof d.action_required === 'object') ? d.action_required : null;
    if (d.status === 'needs_information' || actionReq) {
      var arBox = document.createElement('div');
      arBox.className = 'pp__history-action-required';

      var arTitle = document.createElement('p');
      arTitle.className = 'pp__history-action-required-title';
      arTitle.textContent = 'Action requise';
      arBox.appendChild(arTitle);

      var arLead = document.createElement('p');
      arLead.className = 'pp__history-action-required-lead';
      arLead.textContent = 'OPEN3D a besoin d’un complément pour poursuivre votre demande.';
      arBox.appendChild(arLead);

      var reason = actionReq ? histText(actionReq.reason) : '';
      if (reason) {
        var arReason = document.createElement('p');
        arReason.className = 'pp__history-action-required-reason';
        arReason.textContent = reason;
        arBox.appendChild(arReason);
      } else {
        var arFallback = document.createElement('p');
        arFallback.className = 'pp__history-action-required-reason';
        arFallback.textContent = 'Un complément d’information est nécessaire. OPEN3D vous précisera les éléments attendus.';
        arBox.appendChild(arFallback);
      }

      var reqAt = actionReq ? histFormatDate(actionReq.requested_at) : '';
      if (reqAt) {
        var arDate = document.createElement('p');
        arDate.className = 'pp__history-action-required-date';
        arDate.textContent = 'Demandé le ' + reqAt;
        arBox.appendChild(arDate);
      }

      body.appendChild(arBox);
    }

    var list = document.createElement('div');
    list.className = 'pp__history-detail-list';

    var statusBadge = document.createElement('span');
    statusBadge.className = 'pp__history-badge pp__history-badge--status';
    statusBadge.textContent = histStatusLabel(d.status);
    var statusRow = histDefRow('Statut', '');
    statusRow.querySelector('.pp__history-detail-value').appendChild(statusBadge);
    list.appendChild(statusRow);

    var submitted = d.submitted_at || d.created_at;
    if (submitted) { list.appendChild(histDefRow('Envoyée le', histFormatDate(submitted))); }
    if (d.composition !== undefined && d.composition !== null && HIST_COMPOSITION_LABELS[d.composition]) {
      list.appendChild(histDefRow('Composition', HIST_COMPOSITION_LABELS[d.composition]));
    }
    if (d.base_color) { list.appendChild(histDefRow('Couleur du socle', histText(d.base_color))); }
    var mode = d.shipping && d.shipping.mode;
    if (mode && HIST_DESTINATION_LABELS[mode]) {
      list.appendChild(histDefRow('Destination', HIST_DESTINATION_LABELS[mode]));
    }
    if (d.partner_internal_reference) {
      list.appendChild(histDefRow('Référence de dossier', histText(d.partner_internal_reference)));
    }
    var cust = d.customization || {};
    if (cust.text) { list.appendChild(histDefRow('Texte personnalisé', histText(cust.text))); }
    if (cust.instructions) { list.appendChild(histDefRow('Instructions', histText(cust.instructions))); }
    body.appendChild(list);

    // Photos (rôle FR + nom + miniature si cdn_url HTTPS)
    var photos = Object.prototype.toString.call(d.photos) === '[object Array]' ? d.photos : [];
    if (photos.length) {
      var photosTitle = document.createElement('h4');
      photosTitle.className = 'pp__history-detail-subtitle';
      photosTitle.textContent = 'Photographies';
      body.appendChild(photosTitle);

      var photosWrap = document.createElement('div');
      photosWrap.className = 'pp__history-photos';
      for (var p = 0; p < photos.length; p++) {
        photosWrap.appendChild(histBuildPhoto(photos[p]));
      }
      body.appendChild(photosWrap);
    }

    // Historique des statuts (from_status → to_status + date).
    // Clé serveur prioritaire : status_history ; fallback tolérant : history.
    var isArr = function (v) { return Object.prototype.toString.call(v) === '[object Array]'; };
    var hist = isArr(d.status_history) ? d.status_history : (isArr(d.history) ? d.history : []);
    if (hist.length) {
      var histTitle = document.createElement('h4');
      histTitle.className = 'pp__history-detail-subtitle';
      histTitle.textContent = 'Suivi';
      body.appendChild(histTitle);

      var ul = document.createElement('ul');
      ul.className = 'pp__history-timeline';
      for (var h = 0; h < hist.length; h++) {
        var ev = hist[h] || {};
        var liH = document.createElement('li');
        liH.className = 'pp__history-timeline-item';
        // Première entrée sans statut précédent : afficher uniquement le statut atteint
        // (jamais « — → Envoyée »). Transitions normales : « Envoyée → En cours d'étude ».
        var hasFrom = ev.from_status !== null && ev.from_status !== undefined && ev.from_status !== '';
        var toLabel = histStatusLabel(ev.to_status);
        var transition = hasFrom ? (histStatusLabel(ev.from_status) + ' → ' + toLabel) : toLabel;
        var when = ev.created_at || ev.at || ev.date;
        liH.textContent = when ? (transition + ' · ' + histFormatDate(when)) : transition;
        ul.appendChild(liH);
      }
      body.appendChild(ul);
    }

    if (ctrl.listEl) { ctrl.listEl.hidden = true; }
    histSetHidden(ctrl.paginationEl, true);
    ctrl.detailEl.hidden = false;
    if (typeof ctrl.detailEl.focus === 'function') { ctrl.detailEl.focus(); }
  }

  function histBuildPhoto(photo) {
    var p = photo || {};
    var card = document.createElement('div');
    card.className = 'pp__history-photo';

    if (histIsHttps(p.cdn_url)) {
      var img = document.createElement('img');
      img.className = 'pp__history-photo-img';
      // src via propriété (jamais innerHTML) + variation Uploadcare de miniature.
      img.src = p.cdn_url + '-/preview/160x160/-/quality/smart/';
      img.loading = 'lazy';
      img.width = 80;
      img.height = 80;
      img.setAttribute('alt', HIST_PHOTO_ROLE_LABELS[p.role] || 'Photographie');
      card.appendChild(img);
    }

    var caption = document.createElement('p');
    caption.className = 'pp__history-photo-caption';
    var roleLabel = HIST_PHOTO_ROLE_LABELS[p.role] || histText(p.role) || 'Photographie';
    caption.textContent = roleLabel;
    if (p.name) {
      // Nom borné (ellipse via CSS) ; nom complet accessible via title.
      caption.appendChild(document.createTextNode(' · '));
      var nameEl = document.createElement('span');
      nameEl.className = 'pp__history-photo-name';
      nameEl.textContent = histText(p.name);
      nameEl.setAttribute('title', histText(p.name));
      caption.appendChild(nameEl);
    }
    card.appendChild(caption);

    return card;
  }

  function bindGlobalListeners() {
    if (PP.listenersBound) { return; }
    PP.listenersBound = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    } else {
      initAll(document);
    }

    // Rechargement de section dans l'éditeur Shopify
    document.addEventListener('shopify:section:load', function (event) {
      var target = event && event.target ? event.target : document;
      if (target.matches && target.matches('[data-pp-root]')) { initAuth(target); }
      if (target.matches && target.matches('[data-pp-request]')) { initRoot(target); }
      initAll(target);
    });
  }

  bindGlobalListeners();
})();
